<script>
  import { getStyleValue } from "../../Common/tools";
  import {External} from "../../external";

  export let data,
    globalStyle,
    isChild = false,
    style = "";

  let align;
  $: {
    if (!data.style.position || data.style.position === "" || data.style.position === "left") {
      align = "component-left";
    } else if (data.style.position === "center") {
      align = "component-center";
    } else {
      align = "component-right";
    }
  }
</script>

{#if isChild}
  <div style={style}>
    <a href="" style="color: {data.style.color};text-decoration:none;pointer-events:none;{style}">{data.label}</a>
  </div>
{:else}
  {#if (External.Website.emailMarketingSettings.companyName || External.Website.emailMarketingSettings.companyAddress) && data.style.brandingPosition !== "left"}
    <tr>
      <th
        class="column column-st"
        width={getStyleValue(globalStyle.width, 600)}
        style="color: {data.style.brandColor};text-align: {data.style.position}; padding-left: 40px; padding-right: 40px;">
        {#if External.Website.emailMarketingSettings.companyName}{External.Website.emailMarketingSettings.companyName}{/if}
        {#if External.Website.emailMarketingSettings.companyName && External.Website.emailMarketingSettings.companyAddress}<br />{/if}
        {#if External.Website.emailMarketingSettings.companyAddress}{External.Website.emailMarketingSettings.companyAddress}{/if}
      </th>
    </tr>
    <tr>
      <td class="spacer" height="10" style="line-height: 10px;">
        <div class="spacer-bottom ui-resizable" style="bottom: 0px; position: absolute; width: 100%; height: 10px;">
          &nbsp;
          <div class="ui-resizable-handle ui-resizable-s" style="z-index: 90; bottom: 0px; top: 0px; height: unset; position: absolute;" />
        </div>
      </td>
    </tr>
  {/if}
  <tr>
    <th class="column column-st" width={getStyleValue(globalStyle.width, 600)} style="text-align: {data.style.position}; padding-left: 40px; padding-right: 40px;">
      {#if (External.Website.emailMarketingSettings.companyName || External.Website.emailMarketingSettings.companyAddress) && data.style.brandingPosition === "left"}
        <span style="color: {data.style.brandColor};">
          {#if External.Website.emailMarketingSettings.companyName}{External.Website.emailMarketingSettings.companyName} | {/if}
          {#if External.Website.emailMarketingSettings.companyAddress}{External.Website.emailMarketingSettings.companyAddress} | {/if}
        </span>
      {/if}

      <a href="" style="color: {data.style.color};text-decoration:none;pointer-events:none;{style}">{data.label}</a>
    </th>
  </tr>
{/if}
